import { combineReducers } from 'redux';

import globalReducer from './global/globalSlice';
import adminReducer from './admin/adminSlice';
import foilReducer from './foil/foilSlice';
import catalogReducer from './catalog/catalogSlice';

export default combineReducers({
  globalReducer,
  adminReducer,
  foilReducer,
  catalogReducer,
});
